import React from 'react';
import { Container, Row, Col, Card } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import { MisHeader } from '../Components/MisHeader';


export const HomePage = () => {
  return (
    <div  className='min-vh-100' >
        <MisHeader className= "max-vh-10"/>
      <div className=' min-vh-100 d-flex justify-content-center align-items-center' style={{ paddingBottom: "150px" }}>

        <Col md={5} className=" w-50 align-self-center">
          <Row className="g-10">
            <Col md={6}>
              <Card className="new-consent-card text-white p-4">
                <Card.Body>
                  <h4 className="fw-bold mb-4">MIS Portal</h4>
                  <Link 
                    to="/mis-user-login"
                    className="btn btn-light w-100 fw-500"
                  >
                    Login to MIS
                  </Link>
                </Card.Body>
              </Card>
            </Col>
            <Col md={6}>
              <Card className="manage-consent-card text-white p-4">
                <Card.Body>
                  <h4 className="fw-bold mb-4">Consent Portal</h4>
                  <Link 
                    to="/consent-login"
                    className="btn btn-light w-100 fw-500"
                  >
                    Login to Consent
                  </Link>
                </Card.Body>
              </Card>
            </Col>
          </Row>
        </Col>
      </div>
    </div>
  );
};

export default HomePage;